import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContactCards({ address, phone, email, website }) {
  const { t } = useTranslation();
  const hasAny = address || phone || email || website;
  if (!hasAny) return null;

  const mapsUrl = address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
    : null;
  const websiteUrl = website
    ? (website.trim().startsWith('http') ? website : `https://${website}`)
    : null;

  return (
    <section className="ri-section ri-contact" aria-labelledby="ri-contact-heading">
      <h2 id="ri-contact-heading" className="ri-section-title">
        <span className="ri-section-icon" aria-hidden="true">📬</span>
        {t('restaurant.info.contact')}
      </h2>
      <div className="ri-contact-grid">
        {phone && (
          <a href={`tel:${phone.trim()}`} className="ri-contact-card" aria-label={t('restaurant.info.callRestaurant', 'Call restaurant')}>
            <span className="ri-contact-icon" aria-hidden="true">📞</span>
            <span className="ri-contact-label">{t('restaurant.info.phone')}</span>
            <span className="ri-contact-value">{phone}</span>
            <span className="ri-contact-cta">{t('restaurant.info.callNow', 'Call Now')}</span>
          </a>
        )}
        {email && (
          <a href={`mailto:${email.trim()}`} className="ri-contact-card" aria-label={t('restaurant.info.emailRestaurant', 'Email restaurant')}>
            <span className="ri-contact-icon" aria-hidden="true">📧</span>
            <span className="ri-contact-label">{t('restaurant.info.email')}</span>
            <span className="ri-contact-value">{email}</span>
            <span className="ri-contact-cta">{t('restaurant.info.emailUs', 'Email Us')}</span>
          </a>
        )}
        {address && (
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="ri-contact-card"
            aria-label={t('restaurant.info.getDirections')}
          >
            <span className="ri-contact-icon" aria-hidden="true">📍</span>
            <span className="ri-contact-label">{t('restaurant.info.address')}</span>
            <span className="ri-contact-value">{address}</span>
            <span className="ri-contact-cta">{t('restaurant.info.getDirections')}</span>
          </a>
        )}
        {websiteUrl && (
          <a
            href={websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="ri-contact-card"
            aria-label={t('restaurant.info.visitWebsite', 'Visit website')}
          >
            <span className="ri-contact-icon" aria-hidden="true">🌐</span>
            <span className="ri-contact-label">{t('restaurant.info.website')}</span>
            <span className="ri-contact-value ri-contact-value--truncate">{website}</span>
            <span className="ri-contact-cta">{t('restaurant.info.visit', 'Visit')}</span>
          </a>
        )}
      </div>
    </section>
  );
}
